"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOpenInspectionDto = instanceOfOpenInspectionDto;
exports.OpenInspectionDtoFromJSON = OpenInspectionDtoFromJSON;
exports.OpenInspectionDtoFromJSONTyped = OpenInspectionDtoFromJSONTyped;
exports.OpenInspectionDtoToJSON = OpenInspectionDtoToJSON;
exports.OpenInspectionDtoToJSONTyped = OpenInspectionDtoToJSONTyped;
/**
 * Check if a given object implements the OpenInspectionDto interface.
 */
function instanceOfOpenInspectionDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('inspectionStartTime' in value) || value['inspectionStartTime'] === undefined)
        return false;
    if (!('inspectionEndTime' in value) || value['inspectionEndTime'] === undefined)
        return false;
    return true;
}
function OpenInspectionDtoFromJSON(json) {
    return OpenInspectionDtoFromJSONTyped(json, false);
}
function OpenInspectionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'inspectionStartTime': (new Date(json['inspectionStartTime'])),
        'inspectionEndTime': (new Date(json['inspectionEndTime'])),
    };
}
function OpenInspectionDtoToJSON(json) {
    return OpenInspectionDtoToJSONTyped(json, false);
}
function OpenInspectionDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'inspectionStartTime': value['inspectionStartTime'].toISOString(),
        'inspectionEndTime': value['inspectionEndTime'].toISOString(),
    };
}
